module.exports = __webpack_public_path__ + "fonts/AvenirNextCondensed-Medium.3e4a9fad.woff";